// Popup.js
'use client';

export default function Popup({ popupId, preparat, onClose, style }) {
    const { vsplyvashka } = preparat || {};
    const { kartinka, tekstovoe_pole, ssylka_na_tovar, ssylka_na_tovar_копия } = vsplyvashka || {};

    const imageUrl = kartinka
        ? `https://dev.vitaline.uz${kartinka.startsWith('//') ? kartinka.replace('//', '/') : kartinka}`
        : null;

    // Обрабатываем ссылку на товар
    let cleanLink = ssylka_na_tovar;

    if (cleanLink) {
        // Заменяем dev.vitaline.uz на www.vitaline.uz
        cleanLink = cleanLink.replace('https://dev.vitaline.uz', 'https://www.vitaline.uz');

        // Проверяем, есть ли /product-tag/ в URL
        if (!cleanLink.includes('/product-tag/') && !cleanLink.includes('/product/')) {
            // Если нет ни /product-tag/, ни /product/, добавляем /product/
            const url = new URL(cleanLink);
            const pathname = url.pathname;

            // Убираем начальный слэш, добавляем /product/ и собираем обратно
            const newPathname = `/product${pathname.startsWith('/') ? pathname : '/' + pathname}`;
            cleanLink = `${url.origin}${newPathname}${url.search}${url.hash}`;
        }
    }

    return (
        <div className="popup fade-in-up" id={popupId} style={style}>
            <div className="popup-content">
                <div className="image-with-link">
                    {imageUrl && (
                        <img
                            className="popup-img"
                            src={imageUrl}
                            alt="Изображение продукции"
                            loading="lazy"
                        />
                    )}
                    {cleanLink && (
                        <a className="ssylka_na_tovar" href={cleanLink}>
                            {ssylka_na_tovar_копия || 'Перейти к товару'}
                        </a>
                    )}
                </div>
                <div className="popup-info" dangerouslySetInnerHTML={{ __html: tekstovoe_pole }} />
                <div className="close-button" onClick={onClose}>
                    <img className="close" src="https://dev.vitaline.uz/wp-content/uploads/schemes/icons/close.png" alt="close" />
                </div>
            </div>
        </div>
    );
}